import { Course, Mobile2Outline } from '@lyearn/icons';
import { adaptSelectedTagsFilterItemsToState } from '@/components/FilterManager/configs/tags';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import type { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import routesContents from '@/pages/corporate/routes/contents';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.MicroLearning];

const config: ContentConfigProps = {
  routes: {
    create: routesContents.MicroLearningCreatorSelector,
    edit: routes.MicroLearningBuilder,
    view: routes.MicroLearningViewer,
    details: routes.MicroLearningDetails,
    manageDetails: routes.AdminMicroLearningDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: Course,
    Create: Mobile2Outline,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
adaptSelectedTagsFilterItemsToState;
